$(document).ready(function () {
  //SVG
  const starIconYellow = `
      <svg width="80" height="20" fill="none" viewBox="0 0 106 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.398 7.263l-6.134-.927L10.484.43c-.272-.573-.716-.573-.989 0L6.714 6.336l-6.135.927c-.623.1-.764.543-.32 1l4.446 4.539-1.059 6.448c-.103.642.263.9.816.6l5.528-3.04 5.526 3.04c.553.313.919.042.816-.6l-1.059-6.448 4.447-4.538c.443-.458.3-.9-.322-1zM40.803 7.263l-6.134-.927L31.889.43c-.273-.573-.716-.573-.989 0l-2.781 5.906-6.135.927c-.623.1-.765.543-.32 1l4.446 4.539-1.06 6.448c-.102.642.263.9.817.6l5.528-3.04 5.525 3.04c.555.313.92.042.817-.6l-1.06-6.448 4.447-4.538c.444-.458.301-.9-.32-1zM62.208 7.263l-6.135-.927L53.293.43c-.272-.573-.716-.573-.989 0l-2.78 5.906-6.135.927c-.624.1-.765.543-.321 1l4.446 4.539-1.059 6.448c-.102.642.263.9.817.6l5.528-3.04 5.526 3.04c.553.313.918.042.815-.6l-1.059-6.448 4.447-4.538c.444-.458.3-.9-.321-1zM83.613 7.263l-6.135-.927L74.698.43c-.272-.573-.716-.573-.989 0l-2.78 5.906-6.135.927c-.624.1-.765.543-.322 1l4.447 4.539-1.059 6.448c-.103.642.263.9.816.6l5.528-3.04 5.527 3.04c.552.313.918.042.815-.6l-1.059-6.448 4.447-4.538c.443-.458.3-.9-.321-1zM105.017 7.263l-6.135-.927L96.102.43c-.272-.573-.716-.573-.988 0l-2.781 5.906-6.135.927c-.623.1-.765.543-.321 1l4.447 4.539-1.06 6.448c-.102.642.263.9.817.6l5.528-3.04 5.525 3.04c.554.313.919.042.817-.6l-1.059-6.448 4.446-4.538c.444-.458.301-.9-.321-1z" fill="#FFD659"/></svg>
      `;
  const starIconGray = `
      <svg width="80" height="20" fill="none" viewBox="0 0 106 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.398 7.263l-6.134-.927L10.484.43c-.272-.573-.716-.573-.989 0L6.714 6.336l-6.135.927c-.623.1-.764.543-.32 1l4.446 4.539-1.059 6.448c-.103.642.263.9.816.6l5.528-3.04 5.526 3.04c.553.313.919.042.816-.6l-1.059-6.448 4.447-4.538c.443-.458.3-.9-.322-1zM40.803 7.263l-6.134-.927L31.889.43c-.273-.573-.716-.573-.989 0l-2.781 5.906-6.135.927c-.623.1-.765.543-.32 1l4.446 4.539-1.06 6.448c-.102.642.263.9.817.6l5.528-3.04 5.525 3.04c.555.313.92.042.817-.6l-1.06-6.448 4.447-4.538c.444-.458.301-.9-.32-1zM62.208 7.263l-6.135-.927L53.293.43c-.272-.573-.716-.573-.989 0l-2.78 5.906-6.135.927c-.624.1-.765.543-.321 1l4.446 4.539-1.059 6.448c-.102.642.263.9.817.6l5.528-3.04 5.526 3.04c.553.313.918.042.815-.6l-1.059-6.448 4.447-4.538c.444-.458.3-.9-.321-1zM83.613 7.263l-6.135-.927L74.698.43c-.272-.573-.716-.573-.989 0l-2.78 5.906-6.135.927c-.624.1-.765.543-.322 1l4.447 4.539-1.059 6.448c-.103.642.263.9.816.6l5.528-3.04 5.527 3.04c.552.313.918.042.815-.6l-1.059-6.448 4.447-4.538c.443-.458.3-.9-.321-1zM105.017 7.263l-6.135-.927L96.102.43c-.272-.573-.716-.573-.988 0l-2.781 5.906-6.135.927c-.623.1-.765.543-.321 1l4.447 4.539-1.06 6.448c-.102.642.263.9.817.6l5.528-3.04 5.525 3.04c.554.313.919.042.817-.6l-1.059-6.448 4.446-4.538c.444-.458.301-.9-.321-1z" fill="#e4e4e4"/></svg>
      `;

  const squareIcon = `<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
          <title>Group 2</title>
          <desc>Created with Sketch.</desc>
          <g id="MOCKS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="DAC_-ANIMAL-REFINE" transform="translate(-1055.000000, -433.000000)" stroke="#2D2D2D" stroke-width="0.75">
                  <g id="Group-2" transform="translate(1055.000000, 433.000000)">
                      <rect id="Rectangle" x="0.375" y="0.375" width="19.25" height="19.25"></rect>
                      <rect id="Rectangle" x="3.375" y="3.375" width="13.25" height="13.25"></rect>
                      <rect id="Rectangle" x="5.375" y="5.375" width="9.25" height="9.25"></rect>
                      <line x1="14.8310644" y1="5.08462789" x2="19.5360773" y2="0.541049653" id="Line-7" stroke-linecap="square" transform="translate(17.166126, 2.587552) rotate(-1.000000) translate(-17.166126, -2.587552) "></line>
                      <line x1="0.462517934" y1="4.79502053" x2="5.16753088" y2="0.251442295" id="Line-7" stroke-linecap="square" transform="translate(3.125508, 2.670586) scale(1, -1) rotate(-1.000000) translate(-3.125508, -2.670586) "></line>
                      <line x1="14.7531358" y1="19.45326" x2="19.5396612" y2="14.9552775" id="Line-7" stroke-linecap="square" transform="translate(17.043288, 17.206026) scale(1, -1) rotate(-1.000000) translate(-17.043288, -17.206026) "></line>
                      <line x1="0.463199218" y1="19.4538638" x2="5.16821217" y2="14.9102856" id="Line-7" stroke-linecap="square" transform="translate(3.124943, 17.368455) rotate(-1.000000) translate(-3.124943, -17.368455) "></line>
                  </g>
              </g>
          </g>
      </svg>`;

  const roundIcon = `<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
          <title>PDP_DIAMOND SHAPE</title>
          <desc>Created with Sketch.</desc>
          <g id="MOCKS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="DAC_PDP-w.-COPY" transform="translate(-200.000000, -694.000000)" stroke="#2D2D2D" stroke-width="0.75">
                  <g id="PRODUCT-DETAILS" transform="translate(200.000000, 192.000000)">
                      <g id="PDP_DIAMOND-SHAPE" transform="translate(0.000000, 502.000000)">
                          <circle id="Oval" cx="10" cy="10" r="9.625"></circle>
                          <rect id="Rectangle" x="3.27449494" y="3.27449494" width="13.25" height="13.25"></rect>
                          <path d="M16.5244949,3.27449494 L3.27449494,3.27449494 L3.27449494,16.5244949 L16.5244949,16.5244949 L16.5244949,3.27449494 Z" id="Rectangle" transform="translate(9.899495, 9.899495) rotate(45.000000) translate(-9.899495, -9.899495) "></path>
                      </g>
                  </g>
              </g>
          </g>
      </svg>`;

  //Shapes
  const renderProductShape = (productShape) => {
    const shape = productShape.toLowerCase();
    return shape === "round" ? roundIcon : squareIcon;
  };
  //Price
  const renderPriceRecently = (productAvailable, price, comparePrice, productId) => {
    if (productAvailable === "true") {
      if (comparePrice) {
        return `
                  <div class="flex items-center space-x-2">
                      <del class="min-w-fit flex items-center justify-center xl:justify-start gap-2 py-2">
                          ${comparePrice}
                      </del>
                      <span class="min-w-fit flex items-center justify-center xl:justify-start gap-2 py-2 text-[#D91945]">
                          ${price}
                      </span>
                  </div>
                  `;
      } else {
        return `
                  <span class="min-w-fit flex items-center justify-center xl:justify-start gap-2 py-2">
                      ${price}
                  </span>
              `;
      }
    } else {
      return `
          <span
            x-data
            x-html="() => $store.backInStock.getOutOfStockMessage('${productId}')"
            class="min-w-fit flex items-center justify-center xl:justify-start gap-2 py-2 text-[#D91945]"
          >
              
          </span>
          `;
    }
  };

  const haveReview = (productReviews) => {
    return Number(productReviews) > 0 ? starIconYellow : starIconGray;
  };

  //Badge Tags
  const productBadge = (productTag) => {
    productTag = productTag.split(",");

    if (productTag.includes("Good For Beginners")) {
      return `
          <div
              style="background: linear-gradient(101.98deg, rgba(0, 255, 163, 0.15) 41.25%, rgba(0, 255, 224, 0.15) 91.16%);"
              class="py-1 px-2 text-[7px] lg:text-[9px] leading-[.375rem] tracking-wider uppercase text-[#27C9B5] border border-[#27C9B5] rounded-full">
              <span>Beginner Friendly</span>
          </div>
          `;
    } else if (productTag.includes("lowstock")) {
      return `
          <div
              style="background: linear-gradient(101.98deg, #FFE2CC 41.25%, #FFD88B 91.16%);"
              class="py-1 px-2 text-[7px] lg:text-[9px] leading-[.375rem] tracking-wider uppercase text-[#FF5C00] border border-[#FF5C00] rounded-full">
              <span>Low Stock</span>
          </div>
          
          `;
    } else if (productTag.includes("final-edition")) {
      return `
          <div
              style="background: linear-gradient(98.24deg, #FFEDE3 10.21%, #FFCEC7 91.23%);"
              class="py-1 px-2 text-[7px] lg:text-[9px] leading-[.375rem] tracking-wider uppercase text-[#E64623] border border-[#F73326] rounded-full">
              <span>Final Edition</span>
          </div>
          
          `;
    } else if (productTag.includes("blackfriday")) {
      return `
          <span class="GalleryProduct-label --black-friday lazyload">
              Black Friday
          </span>
          `;
    } else if (productTag.includes("limited-edition")) {
      return `
          <div
              style="background: linear-gradient(101.98deg, #FFE2CC 41.25%, #FFD88B 91.16%);"
              class="py-1 px-2 text-[7px] lg:text-[9px] leading-[.375rem] tracking-wider uppercase text-[#FF5C00] border border-[#FF5C00] rounded-full">
              <span>Limited Edition</span>
          </div>
          `;
    } else if (
      productTag.includes("bestseller") ||
      productTag.includes("best-seller")
    ) {
      return `
          <div
              style="background: linear-gradient(101.98deg, #B2EFF7 41.25%, #B8DBFB 91.16%);"
              class="py-1 px-2 text-[7px] lg:text-[9px] leading-[.375rem] tracking-wider uppercase text-[#2D77BB] border border-[#2D77BB] rounded-full">
              <span>Best Seller</span>
          </div>
          `;
    } else if (productTag.includes("newarrival")) {
      return `
          <div
              style="background: linear-gradient(98.24deg, #dfccf7 10.21%, #c4a3f0 91.23%);"
              class="py-1 px-2 text-[7px] lg:text-[9px] leading-[.375rem] tracking-wider uppercase text-[#6633a7] border border-[#6633a7]/50 rounded-full">
              <span>New Arrival</span>
          </div>
          `;
    } else if (productTag.includes("discontinued")) {
      return `
          <div
            style="background: linear-gradient(101.98deg, #F4F4F4 41.25%, #E9E7EA 91.16%);"
            class="w-fit py-1 px-2 text-[7px] lg:text-[9px] leading-[.375rem] tracking-wider uppercase text-[#2d2d2d] border border-[#E8E7EA] rounded-full">
              <span>Archived</span>
          </div>
          `;
    } else {
      return `<div></div>`;
    }
  };

  //Cards
  const recentlyCard = (item) => {
    return `
    <article class="flex flex-col xl:px-4 xl:py-2 rounded-md bg-white shadow-[0px_1px_11px_rgba(212,173,186,.4)] transition-transform hover:scale-[1.015]">
        <div class="flex items-center justify-between bg-white pb-1 xl:pt-0 pt-1 px-2 xl:px-0 xl:mb-1 rounded-t-md">
            <div>
                ${productBadge(item.productTag)}
            </div>
            <button name="likes" data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product product_${
              item.productId
            }" data-swaction="addToWishlist" data-product-id="${
      item.productId
    }" data-variant-id="${item.productFirstVariable}" data-product-url="${
      item.shopUrl
    }${item.productUrl}"></button>
        </div>
        <figure>
            <a href="${
              item.productUrl
            }" class="bg-neutral-100 relative pb-[100%] grid items-center justify-center">
                <img src="${item.productImg}" alt="${
      item.productImageAltText
    }" loading="lazy" width="300" height="250" class="absolute object-contain max-h-full" sizes="(max-width: 360px) 169px, (max-width: 375px) 176px, (max-width: 414px) 195px, (max-width: 767px) 364px">
            </a>
        </figure>
        <div class="flex flex-col justify-between flex-1 text-center xl:text-left py-1">
            <div class="flex-1 flex flex-col justify-between">
                <h3 class="font-title">
                    <a href="${
                      item.productUrl
                    }" class="block text-sm lg:text-lg">${item.productTitle}</a>
                </h3>
                <div>
                    <p class="text-[11px] text-neutral-500">
                        <a href="${item.productUrl}">${
      item.productVendor.includes("©")
        ? item.productVendor.replace("By", "")
        : `© ${item.productVendor.replace("By", "")}`
    }</a>
                    </p>
                    <div class="flex items-center justify-center xl:justify-start gap-2">
                        ${haveReview(item.productReviews)}
                        <span class="text-xs font-normal uppercase">${
                          Number(item.productReviews) > 0
                            ? `(${item.productReviews} Review)`
                            : "New Release"
                        }</span>
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-center xl:justify-start  gap-2 font-title font-bold text-sm">
                <div>
                    ${renderProductShape(item.productShape)}
                </div>
                ${renderPriceRecently(
                  item.productAvailable,
                  item.productPrice,
                  item.productComparePrice,
                  item.productId
                )}

                
            </div>
            <div class="md:pb-0 pb-5">
                ${
                  item.productAvailable === "true"
                    ? `
                <form action="${item.cartAddUrl}" method="post">
                    <input type="hidden" name="id" value="${item.productFirstVariable}" />
                    <input type="hidden" name="quantity" value="1" />
                    <button type="submit" class="flex items-center justify-center mx-auto w-36 xl:w-full py-1 lg:py-3 rounded-full bg-black hover:bg-neutral-600 text-white text-[9px] lg:text-xs leading-4 tracking-wider font-bold uppercase">
                        <div class="animate-spin w-4 h-4 animate-none hidden">
                            <svg role="none" class="text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div>
                        <span>Add to cart</span>
                    </button>
                </form>
                `
                    : `
                <a href="${item.productUrl}" class="flex items-center justify-center mx-auto w-36 xl:w-full py-1 lg:py-3 rounded-full bg-black hover:bg-neutral-600 text-white text-[9px] lg:text-xs leading-4 tracking-wider font-bold uppercase">
                    View product
                </a>
        `
                }
            </div>
        </div>
    </article>
`;
  };
  const productSkeleton = document.querySelectorAll(".product-card-skeleton");

  function removeSkeleton() {
    productSkeleton.forEach((item) => {
      item.remove();
    });
  }

  //Recently Viewed Products
  function renderRecentlyViewedProducts() {
    removeSkeleton();
    const productData = JSON.parse(
      localStorage.getItem("recentlyViewedProduct")
    );
    const recentlyViewedHtml = [];

    //Render
    productData.map((item) => {
      recentlyViewedHtml.unshift(recentlyCard(item));
    });
    const newProductData = `${recentlyViewedHtml.join("")}`;
    const fullContent = document.getElementsByClassName("recently-viewed");
    const renderRecommendationTitle = document.querySelector(
      "#render-recommendations-title"
    );
    renderRecommendationTitle.innerText = "Recently Viewed Items";
    fullContent[0].innerHTML = newProductData;
  }

  //Best Sellers
  function renderBestSellers() {
    const bestSellers = document.querySelector("#best-sellers");
    const renderRecommendations = document.querySelector(
      "#render-recommendations"
    );
    const renderBestSellersTitle = document.querySelector(
      "#render-bestSeller-title"
    );

    renderBestSellersTitle.innerText = "Best Sellers";
    renderRecommendations.classList.add("hidden");
    bestSellers.classList.remove("hidden");
    removeSkeleton();
  }

  //WishList
  function renderWishlistProducts() {
    function swymCallbackFn(swat) {
      const fullContent = document.querySelector(".recently-viewed");
      const renderRecommendationTitle = document.querySelector(
        "#render-recommendations-title"
      );
      swat.fetch(function (wishlistProducts) {
        renderRecommendationTitle.innerText = "Wishlist";
        wishlistProducts.slice(0, 4).forEach((product) => {
          const productHandle = product.du.split("/")[4].split("?")[0];
          fetch(
            `${Shopify.routes.root}products/${productHandle}?section_id=product-card-ajax`
          )
            .then((r) => r.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              const cardHTML = doc.querySelector("div").innerHTML;
              removeSkeleton();
              fullContent.innerHTML += cardHTML;
            });
        });
      });
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(swymCallbackFn);
  }

  const productData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));

  function swymCallbackFne(swat) {
    swat.fetch(function (products) {
      if (products.length > 0) {
        renderWishlistProducts();
      } else if (products.length === 0 && productData) {
        renderRecentlyViewedProducts();
      } else {
        renderBestSellers();
      }
    });
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFne);
});
